export default __webpack_public_path__ + "static/media/school.94489dad.webp";